import isEmpty from 'lodash-es/isEmpty';
import isEqual from 'lodash-es/isEqual';
import xorWith from 'lodash-es/xorWith';
import { isRelativeURL, isAbsoluteURL } from '@config/utils';

export function helperFunctions (app) {
    return {
        messages:
        {
            showToast: function(message, title, type, callbackClose, timeout = 3000, clear = true)
            {
                if(clear) {
                    app.$toastr.removeByName("toastrmsg");
                }
                app.$toastr.Add({
                    name                : "toastrmsg",
                    msg                 : message,
                    title               : title,
                    clickClose          : true,
                    position            : "toast-top-right",
                    type                : type,
                    preventDuplicates   : false,
                    timeout             : timeout,
                    closeButton         : true,
                    onClosed            : callbackClose
                });
            },
            removeToast: function(){
                app.$toastr.removeByName("toastrmsg");
            },
        },
        validators:
        {
            validateEmail: function (email)
            {
                var re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return re.test(email);
            },
        },
        error:{
            httpError: function(error, timeout = 8000){
                let type = 'error';
                let title = 'Error';
                let msg = null;
                let callbackClose = ()=>{};
                error = error?.response?.data ?? error;

                if (error.response) {
                    let res = error.response;

                    switch(res.status)
                    {
                        case 403:
                            title = 'Acesso Negado';
                            msg = res.message?res.message:(res.data.message?res.data.message:res.data.data);
                            break;
                        case 422:
                            title = 'Erro no processamento';
                            msg = res.message?res.message:(res.data.message?res.data.message:res.data.data);
                            break;
                        default:
                            title = 'Erro Interno';
                            msg = 'Não foi possível processar o pedido. Entre em contato com o suporte técnico';
                            break;
                    }
                }else if(error.message){
                    if(error.title) title = error.title;
                    msg = error.message;
                }else if(error.error){
                    msg = "";
                    if( typeof error.error === 'string' ) {
                        msg = error.error;
                    }else{
                        for (const [key, value] of Object.entries(error.error)) {
                            msg += '<p class="mb-2">' + value.join('</p><p>') + '</p>';
                        }
                    }
                    if(error.title) title = error.title;
                    msg = msg?msg:"Ocorreu um erro";
                }else if(typeof error == 'object'){
                    console.error(error)
                }else if (!error.response){
                    title = 'Servidor';
                    msg = 'Não foi possível ligar ao servidor';
                }
                if(msg) {
                    app.$helper.messages.showToast(msg, title, type, callbackClose, timeout);
                }
            }
        },
        images:
        {
            getDataUri: function(url, callback) {
                var image = new Image();

                image.onload = function () {
                    var canvas = document.createElement('canvas');
                    canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
                    canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size

                    canvas.getContext('2d').drawImage(this, 0, 0);

                    // ... or get as Data URI
                    callback(canvas.toDataURL('image/png'));
                };

                image.src = url;
            }
        },
        cookie:
        {
            setCookie: function(cname, cvalue, exdays)
            {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                var expires = "expires="+d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            },
            getCookie: function(cname)
            {
                var name = cname + "=";
                var ca = document.cookie.split(';');

                for(var i = 0; i < ca.length; i++)
                {

                    var c = ca[i];

                    while (c.charAt(0) == ' ')
                    {
                        c = c.substring(1);
                    }

                    if (c.indexOf(name) == 0)
                    {
                        return c.substring(name.length, c.length);
                    }
                }

                return null;
            }
        },
        color:
        {
            convertHex: function (color, opacity=.5)
            {
                if(!color){
                    return '';
                }
                color = color.replace('#', '');
                let r = parseInt(color.substring(0, 2), 16);
                let g = parseInt(color.substring(2, 4), 16);
                let b = parseInt(color.substring(4, 6), 16);
                let result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
                return result;
            },
        },
        theme: {
            assetsPathTheme: function(target) {
                return require(`@images/themes/${app.$root.$env.THEME_NAME}${target}`);
            },
            assetsPathModule: function(module, target) {
                return require(`@modules/${module}/images/themes/${app.$root.$env.THEME_NAME}${target}`);
            },
            assetsPathGlobal: function(target) {
                return require(`@images/${target}`);
            },
        },
        platform: {
            assetsPathModulePlatform: function(module, target)
            {
                return require(`@modules/${module}/images/platforms/${app.$root.$env.PLATFORM}/images${target}`);
            },
            assetsPathGlobalPlatform: function(target)
            {
                return require(`@images/platforms/${app.$root.$env.PLATFORM}${target}`);
            },
        },
        array:
        {
            isArrayEqual: function(x, y) {
                return isEmpty(xorWith(x, y, isEqual));
            }
        },
        global: {
            allowUserRegistration: function(){
                return app.$root.$env.ALLOW_USER_REGISTRATION == undefined ? true : app.$root.$env.ALLOW_USER_REGISTRATION;
            },
            getMinPasswordLength: function(){
                return app.$root.$env.MIN_LENGTH_PWD;
            },
            formatUrlAPI(path) {
                return path ?
                    (isRelativeURL(path) ? `${app.$root.$env.API_URL}/${path}`.replace(/([^:]\/)\/+/g, "$1") : path)
                    : '';
            },
            resetUrlAPI(url) {
                return url ?
                    (isAbsoluteURL(path) ? `${url}`.replace(app.$root.$env.API_URL, "").replace(/^\/|\/$/g, '') : path)
                    : '';
            },
            activeTooltip(boundary='window') {
                let el = $('[data-toggle="tooltip-city"]');
                if(el && el.tooltip) {
                    try {
                        el.tooltip('dispose');
                        el.tooltip({html: true, boundary: boundary});

                        el.on('click', function () {
                            $(this).tooltip('hide');
                        });
                    }
                    catch(err){
                        if(app.$root.$env.DEBUG) {
                            console.error(err);
                        }
                    }
                }
            },
            hideTooltip() {
                let el = $('[data-toggle="tooltip-city"]');
                if(el && el.tooltip) {
                    try {
                        el.tooltip('hide');
                    }
                    catch(err){
                        if(app.$root.$env.DEBUG) {
                            console.error(err);
                        }
                    }
                }
            },
        },
        string: {
            normalize: function(str){
                return str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : str;
            },
            interpolate: function(str, obj) {
                const names = Object.keys(obj);
                const vals = Object.values(obj);
                return new Function(...names, `return \`${str}\`;`)(...vals);
            }
        },
        function: {
            isArray: (a) => !!a && a.constructor === Array,
            isObject: (a) => !!a && a.constructor === Object,
            isEvent: (e) => !!e && e.constructor === Event,
            isPromise: (e) => !!e && e.constructor.name === Promise,
            hasValue: (value) => value !== undefined && value !== null && value !== '',
        }
    }
};